import React, { useContext } from 'react';
import UserPrefsContext from '../../../context/UserPrefs/UserPrefsContext';

import './RateDetails.scss';
import { useIntl } from 'react-intl';

const RateDetails = ({ rates }) => {
  const intl = useIntl();
  const userPrefs = useContext(UserPrefsContext);
  const selectedRateDetailsId = userPrefs.get('selectedRateDetailsId');

  const selectedRate = rates.find((rate) => rate.id === selectedRateDetailsId);
  const SelectedDetailsComponent =
    (selectedRate || {}).detailsComponent || (() => null);

  const getName = (rate) => {
    if (rate.id === 'TOD') {
      return intl.formatMessage({
        id: 'rs.timeOfDay',
        defaultMessage: 'Time-of-Day rate',
      });
    }

    if (rate.id === 'R14') {
      return intl.formatMessage({
        id: 'rs.fixed',
        defaultMessage: 'Fixed rate',
      });
    }

    if (rate.id === 'TODEV') {
      return intl.formatMessage({
        id: 'rs.timeOfDayEV',
        defaultMessage: 'Time-of-Day with EV Credit Rate',
      });
    }

    return `${rate.title} ${rate.subTitle}`;
  };

  return (
    <div className="chart-details-container">
      <div>
        <div className="d-flex mb-4">
          {rates.map((rate) => {
            return (
              <button
                className={`btn chartBtn-${
                  rate.id === selectedRateDetailsId ? 'ae' : 'secondary'
                } mr-2`}
                key={rate.id}
                onClick={() =>
                  userPrefs.set({ selectedRateDetailsId: rate.id })
                }
              >
                {getName(rate)}
              </button>
            );
          })}
        </div>
        <div className="chart-details">
          <SelectedDetailsComponent />
          <a
            href="https://www.smud.org/Rate-Information/Residential-rates"
            className="btn-smud-secondary"
            target="_blank"
            rel="noopener noreferrer"
          >
            {intl.formatMessage({
              id: 'rateDetails.learnMore',
              defaultMessage: 'Learn more',
            })}
          </a>
        </div>
      </div>
    </div>
  );
};

export default RateDetails;
